import { Component, ElementRef, HostListener, Inject } from '@angular/core';
import { WINDOW } from '@inshared/shared/util';

@Component({
    selector: 'ins-funnel-entry-sticky',
    templateUrl: 'funnel-entry-sticky.component.html',
    styleUrls: ['funnel-entry-sticky.component.scss']
})
export class FunnelEntryStickyComponent {
    public show: boolean = false;

    constructor(
        public el: ElementRef,
        @Inject(WINDOW) private window: Window,
    ) {}

    // TODO: check if this will perform on mobile (because of constant scroll event firing)
    @HostListener('window:scroll', ['$event']) checkScroll(): void {
        const componentPosition = this.el.nativeElement.offsetTop;
        const scrollPosition = this.window.pageYOffset;

        this.show = scrollPosition >= componentPosition;
    }
}
